module.exports = __webpack_public_path__ + "img/gallery1.6b6423e3.webp";